import { MainSite } from "./Icon.Midi.WebApplication.FrontEnd/MainSite";

MainSite.run(); 